export const frontmatter = {
  title: "Treasury",
  order: 8,
}

| Address                                                                                                             | Wallet                |
| ------------------------------------------------------------------------------------------------------------------- | --------------------- |
| [0x9A134D3BdEB95C8C8773bD7627f1FDD792531C97](https://debank.com/profile/0x9A134D3BdEB95C8C8773bD7627f1FDD792531C97) | Main Team Multisig    |
| [0x7D970D34a041251a4500Fc4997C6f74104f16d23](https://debank.com/profile/0x7D970D34a041251a4500Fc4997C6f74104f16d23) | Recycling / Processor |
| [0xd9Ae2C82b62000c95091f38Bb1e796cc9899Ee07](https://debank.com/profile/0xd9Ae2C82b62000c95091f38Bb1e796cc9899Ee07) | Processing DeFi       |
